import ExecutionEnvironment from 'exenv';

export const isClient = () => ExecutionEnvironment.canUseDOM;
export const isServer = () => !isClient();
